import { render, staticRenderFns } from "./TrainingStylistsList.vue?vue&type=template&id=13c1ca57&"
import script from "./TrainingStylistsList.vue?vue&type=script&lang=js&"
export * from "./TrainingStylistsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports